/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable max-len */
import React from 'react';

interface OneSightLogoLightProps {
  height?: number;
}

export const OneSightLogoLight = ({ height = 19 }: OneSightLogoLightProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 4000 958" fill="none">
    <path
      d="M587.543 934.11C795.454 934.11 964 766.321 964 559.342C964 352.363 795.454 184.573 587.543 184.573C379.631 184.573 211.086 352.363 211.086 559.342C211.086 766.321 379.631 934.11 587.543 934.11Z"
      fill="#FFC400"
      stroke="#FFC22B"
      strokeWidth="14.5145"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M511.999 184.5C524.225 183.305 547.499 177 586.499 177C808.999 177 963.999 349.459 963.999 555.993C963.999 762.561 798.675 937 590.863 937C578.333 937 522.336 931.863 510.109 930.655C700.494 912.09 840.386 721.972 840.386 527.86C840.386 333.748 702.383 203.062 511.999 184.5Z"
      fill="#808080"
      fillOpacity="0.49"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1084.3 456.707C1080.95 417.667 1037.23 370.262 996.76 371.182L934.46 370.776C912.599 370.776 929.044 388.815 929.044 410.666C948.574 496.751 949.526 585.492 929.044 677.3C929.044 699.157 915.389 714.605 937.217 714.605L1017.96 714.222C1057.58 711.866 1083.12 670.125 1084.27 631.999L1084.3 456.707Z"
      fill="#253858"
      stroke="#253858"
      strokeWidth="13.1451"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00021 456.707C10.3483 417.667 54.07 370.262 94.5423 371.182L156.843 370.776C178.704 370.776 162.259 388.815 162.259 410.666C142.728 496.751 141.776 585.492 162.259 677.3C162.259 699.157 175.914 714.605 154.086 714.605L73.3379 714.222C33.719 711.866 8.18192 670.125 7.03307 631.999L7.00021 456.707Z"
      fill="#253858"
      stroke="#253858"
      strokeWidth="13.1451"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M550.257 144.171C337.825 144.171 165.8 315.58 165.8 526.796C165.8 738.011 337.825 909.42 550.257 909.42C762.689 909.42 934.714 738.011 934.714 526.796C934.714 315.58 762.689 144.171 550.257 144.171ZM117.506 526.796C117.506 288.704 311.358 95.877 550.257 95.877C789.157 95.877 983.008 288.704 983.008 526.796C983.008 764.888 789.157 957.714 550.257 957.714C311.358 957.714 117.506 764.888 117.506 526.796Z"
      fill="#253858"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M547.111 51.1929C290.426 51.1929 83.2261 251.145 83.2261 495.971C83.2261 505.433 75.5552 513.104 66.0926 513.104C56.6299 513.104 48.959 505.433 48.959 495.971C48.959 230.924 272.823 16.9258 547.111 16.9258C821.4 16.9258 1045.26 230.924 1045.26 495.971C1045.26 505.433 1037.59 513.104 1028.13 513.104C1018.67 513.104 1011 505.433 1011 495.971C1011 251.145 803.797 51.1929 547.111 51.1929Z"
      fill="#253858"
    />
    <path
      d="M990.198 370.776H971.482V733.856H990.198V370.776Z"
      fill="white"
      stroke="white"
      strokeWidth="0.677391"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M121.525 370.776H102.809V733.856H121.525V370.776Z"
      fill="white"
      stroke="white"
      strokeWidth="0.677391"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M558.014 697.41C628.838 697.41 686.336 668.612 686.336 676.742C686.336 684.872 628.838 746.188 558.014 746.188C487.189 746.188 429.691 684.872 429.691 676.742C429.691 668.612 487.189 697.41 558.014 697.41Z"
      fill="#253858"
      stroke="#253858"
      strokeWidth="28.5799"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M297.283 468.54C347.974 523.872 418.995 516.708 457.909 448.206"
      stroke="#253858"
      strokeWidth="46.7288"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M625.699 461.249C661.582 527.068 732.257 537.068 786.536 479.854"
      stroke="#253858"
      strokeWidth="46.7859"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M790.548 115.811C790.548 115.811 794.732 70.0166 772.121 56.5643C668.667 -4.96508 407.467 2.63677 318.79 55.2671C298.514 67.3125 304.709 107.006 304.709 107.006C486.073 36.1186 648.45 37.4496 790.548 115.811Z"
      fill="#253858"
      stroke="#253858"
      strokeWidth="24.5235"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1557.89 458.47C1557.89 338.18 1504.33 268.816 1404.24 268.816C1344.53 268.816 1295.36 298.669 1268.14 351.35V277.596H1168.93V721H1268.14V474.274C1268.14 396.13 1309.41 355.74 1369.99 355.74C1431.46 355.74 1458.67 385.593 1458.67 454.079V721H1557.89V458.47Z"
      fill="#253858"
    />
    <path
      d="M1837.81 349.594C1902.78 349.594 1936.15 390.862 1940.54 467.25H1725.42C1732.45 395.252 1767.57 349.594 1837.81 349.594ZM2013.42 703.439V618.27C1972.15 631.441 1925.61 641.099 1873.81 641.099C1780.74 641.099 1736.84 602.466 1726.3 534.858H2036.24V500.615C2036.24 364.521 1980.05 268.816 1840.44 268.816C1702.59 268.816 1627.96 365.399 1627.96 500.615C1627.96 639.343 1701.72 729.78 1871.18 729.78C1919.47 729.78 1975.66 721.878 2013.42 703.439Z"
      fill="#253858"
    />
    <path
      d="M2522.07 556.809C2522.07 457.592 2460.61 411.056 2326.27 381.203C2235.84 359.253 2203.35 339.058 2203.35 298.669C2203.35 253.889 2241.11 231.061 2306.96 231.061C2364.03 231.061 2432.52 244.231 2494.86 275.84V177.501C2452.71 154.672 2393 135.356 2310.47 135.356C2170.86 135.356 2098.87 202.086 2098.87 297.791C2098.87 390.862 2154.18 441.787 2295.54 472.518C2387.74 494.469 2415.83 517.297 2415.83 560.321C2415.83 603.344 2388.61 632.319 2313.1 632.319C2239.35 632.319 2152.43 610.368 2098.87 583.149V684.122C2144.52 707.829 2201.59 729.78 2310.47 729.78C2459.73 729.78 2522.07 661.294 2522.07 556.809Z"
      fill="#253858"
    />
    <path
      d="M2587.63 159.063C2587.63 198.574 2615.73 222.28 2653.48 222.28C2691.24 222.28 2719.34 198.574 2719.34 159.063C2719.34 119.551 2691.24 96.7227 2653.48 96.7227C2615.73 96.7227 2587.63 119.551 2587.63 159.063ZM2603.44 721H2702.65V277.596H2603.44V721Z"
      fill="#253858"
    />
    <path
      d="M3092.07 680.61C3092.07 754.365 3056.95 807.924 2955.1 807.924C2899.78 807.924 2849.74 798.266 2800.57 780.705V873.776C2844.47 887.825 2891 897.483 2961.25 897.483C3126.31 897.483 3190.41 807.924 3190.41 675.342V277.596H3092.07V355.74C3066.61 300.425 3019.2 268.816 2956.86 268.816C2837.44 268.816 2780.37 372.423 2780.37 496.225C2780.37 625.295 2835.69 722.756 2948.08 722.756C3013.05 722.756 3064.85 693.781 3092.07 634.953V680.61ZM2876.95 496.225C2876.95 406.666 2915.59 356.619 2989.34 356.619C3045.54 356.619 3092.07 394.374 3092.07 480.42V510.273C3092.07 597.198 3041.15 635.831 2981.44 635.831C2913.83 635.831 2876.95 589.296 2876.95 496.225Z"
      fill="#253858"
    />
    <path
      d="M3680.07 458.47C3680.07 335.546 3629.15 268.816 3531.69 268.816C3468.47 268.816 3418.42 298.669 3390.33 352.228V98.4787H3291.11V721H3390.33V474.274C3390.33 396.13 3431.59 355.74 3492.18 355.74C3553.64 355.74 3580.86 393.496 3580.86 471.64V721H3680.07V458.47Z"
      fill="#253858"
    />
    <path
      d="M3899.39 572.613V364.521H4005.63V277.596H3899.39V184.525H3801.93V277.596H3738.71V364.521H3801.93V580.515C3801.93 666.562 3845.83 724.512 3945.05 724.512C3972.27 724.512 3989.83 721 4005.63 717.487V626.173C3993.34 628.807 3978.41 631.441 3961.73 631.441C3920.46 631.441 3899.39 608.612 3899.39 572.613Z"
      fill="#253858"
    />
    {/* <path
      d="M4129 275.975C4129 222.417 4172.42 179 4225.98 179H5609.1C5662.66 179 5706.08 222.417 5706.08 275.975V627.025C5706.08 680.583 5662.66 724 5609.1 724H4225.98C4172.42 724 4129 680.583 4129 627.025V275.975Z"
      fill="#DEEBFF"
    />
    <path
      d="M4489.09 564H4545.86L4458.88 313.465H4397.25L4310.26 564H4362.87L4382.14 503.233H4470.17L4489.09 564ZM4424.85 364.336H4427.98L4459.05 463.994H4393.43L4424.85 364.336ZM4749.76 519.9H4638.29V313.465H4585.86V564H4749.76V519.9ZM4794.62 313.465V564H4847.05V485.002H4896.53C4949.31 485.002 4985.95 450.625 4985.95 399.581C4985.95 347.842 4950.7 313.465 4899.14 313.465H4794.62ZM4847.05 355.134H4885.25C4915.46 355.134 4932.64 370.586 4932.64 399.754C4932.64 428.228 4915.11 443.854 4885.07 443.854H4847.05V355.134ZM5249.22 564V313.465H5196.78V415.207H5083.93V313.465H5031.5V564H5083.93V458.438H5196.78V564H5249.22ZM5468.22 564H5524.99L5438.01 313.465H5376.37L5289.39 564H5341.99L5361.27 503.233H5449.29L5468.22 564ZM5403.98 364.336H5407.1L5438.18 463.994H5372.55L5403.98 364.336Z"
      fill="#0747A6"
    /> */}
  </svg>
);
